/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var ConserComplaintSectionCorrespondenceView = require('../views/ConSerComplaintSectionCorrespondenceView');

var GetCorrespondencesByComplaint = require('../services/GetCorrespondencesByComplaint');

module.exports = {
  channel: 'cs',

  event: 'build:complaint-correspondence-view',

  builder: function(complaintId) {
    return new PlaceholderView({
      viewPromise: buildRelatedComplaintSection(complaintId)
    });
  }
};

function buildRelatedComplaintSection(complaintId) {
  var deferred = $.Deferred();
  GetCorrespondencesByComplaint(complaintId)
    .done(function(correspondences) {
      var complaintCorrespondenceSection = new ConserComplaintSectionCorrespondenceView({
        model: new Backbone.Model({ complaintId: complaintId, correspondences: correspondences })
      });
      deferred.resolve(complaintCorrespondenceSection);
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
